import * as React from 'react'
import { Testimonial } from '../Testimonial'
import * as API from './lib/api'

interface IProps {
  testimonials: API.ITestimonial[]
}

export class Testimonials extends React.Component<IProps, object> {
  public render() {
    const { testimonials } = this.props

    return (
      <section className="testimonials list grid-container">
        <div className="grid-x small-up-1 grid-padding-x grid-padding-y">
          {testimonials.map((testimonial) => {
            return (
              <div key={testimonial.name} className="cell text-left">
                <Testimonial testimonial={testimonial} />
              </div>
            )
          })}
        </div>
      </section>
    )
  }
}
